var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"header-container"},[_c('header-vue')],1),_vm._v(" "),_c('section',[_c('transition',[_c('keep-alive',[_c('router-view',{key:_vm.key})],1)],1)],1),_vm._v(" "),(!_vm.mobile)?_c('BacktopBox'):_vm._e(),_vm._v(" "),_c('footer-vue',{})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113e773a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
// module id = null
// module chunks = 